'use strict';

const PULSE_FILE_CATEGORIES = [
  { value: 'rfp', label: 'RFP' },
  { value: 'photo', label: 'Photo' },
  { value: 'drawing', label: 'Drawing' },
  { value: 'correspondence', label: 'Correspondence' },
  { value: 'warranty', label: 'Warranty' },
  { value: 'other', label: 'Other' },
];

export { PULSE_FILE_CATEGORIES };
